export default {
    SEM_ESTOQUE: 1,
    PEDIDO_EM_EXCESSO: 2,
    ENTREGA_PARCIAL: 3,
    PENDENTE_DE_ENTREGA: 4,
    RECUSADO: 5,
    ADEQUACAO_DE_CAIXA: 6,
    OUTRO: 7,
}